const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

export const isValidHexColor = (value: string) => HEX_COLOR_REGEX.test(value);
